import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DeleteOutlined, ExportOutlined, ReloadOutlined } from '@ant-design/icons';
import { Table, Modal, Tooltip, Divider, Tag, DatePicker, Button, Row } from 'antd';
import PageTitle from '../../components/PageTitle';
import TableActionBar from '../../components/TableActionBar';
import _ from 'lodash';
import qs from 'qs';
import TextTruncate from 'react-text-truncate';
import { checkPermission } from '../../utils/permission';
import { cleanObject, stripHtml, ProductReceiptImportType, ConvertProductReceiptImportType, isValidDate, downloadFromLink, vatStatuses } from '../../utils/helpers';
import HtmlParser from 'react-html-parser';
import ProductReceiptImportDetail from './ProductReceiptImportDetail';
import ProductReceiptImportForm from './ProductReceiptImportForm';
import BaseSelect from '../../components/Elements/BaseSelect';
import NumberFormat from 'react-number-format';
import appConfig from '../../config';
import moment from 'moment';

// actions
import {
    getAllProductReceiptImport,
    getSpecificProductReceiptImport,
    removeProductReceiptImport,
    exportExcel
} from '../../redux/actions/ProductReceiptImportActions';
import { getProductSupplierActive } from '../../redux/actions/ProductSupplierAction';
import { getProductWarehouseActive } from '../../redux/actions/ProductWarehouseAction';
import { NotificationManager } from 'react-notifications';

const { confirm } = Modal;
const { RangePicker } = DatePicker;
const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/receipt-import',
        breadcrumbName: 'Phiếu nhập kho',
    },
]

class ProductReceiptImportList extends Component {
    state = {
        isLoading: false,
        selectedRowKeys: [],
        isOpenForm: false,
        currentItem: null,
        isOpenDetail: false,
        current_id: null,
        loadingDetail: false,
        isLoadingExport: false
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoading: true });
        this.props.getAllProductReceiptImport(query).then(() => {
            this.setState({ isLoading: false });
        })
        this.props.getProductSupplierActive();
        this.props.getProductWarehouseActive();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.props.getAllProductReceiptImport(query).then(() => {
                this.setState({
                    isLoading: false
                })
            })
        }
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        if (name === 'created_at') {
            if (value && value.length > 0) {
                query.created_date_start = moment(value[0]).format('YYYY-MM-DD');
                query.created_date_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.created_date_start;
                delete query.created_date_end;
            }
        }
        delete query.created_at;
        query = cleanObject(query);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    toggleOpenForm(isOpenForm, currentItem = null) {
        this.setState({ isOpenForm: isOpenForm, currentItem: currentItem });
    }

    onEdit(id) {
        this.props.getSpecificProductReceiptImport(id).then(res => {
            this.toggleOpenForm(true, res);
        })
    }

    onRemove() {
        this.props.removeProductReceiptImport(this.state.selectedRowKeys).then(() => {
            this.setState({
                selectedRowKeys: []
            });
            setTimeout(() => {
                Modal.destroyAll();
            }, 800);
        })
    }
    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeProductReceiptImport(id).then(() => {
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
            }),
            onCancel() { },
        })
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentItem: data });
    }

    onDetail(id) {
        this.setState({ current_id: id, loadingDetail: true })
        this.props.getSpecificProductReceiptImport(id).then(res => {
            this.setState({ loadingDetail: false })
            this.toggleOpenDetail(true, res);
        })
    }

    reloadData() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoading: true });
        this.props.getAllProductReceiptImport(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    // do_export() {
    //     var query = qs.parse(this.props.location.search.slice(1));
    //     this.setState({ isLoadingExport: true });
    //     this.props.exportExcel(query).then((res) => {
    //         //console.log("res: ", res)
    //         setTimeout(() => {
    //             const response = {
    //                 file: `${appConfig.MEDIA_URL}/${res.path}`,
    //             };
    //             downloadFromLink(response.file, "_product_receipt_import.xlsx");
    //         }, 100);
    //         this.setState({ isLoadingExport: false });
    //     }).catch(err => {
    //         this.setState({ isLoadingExport: false });
    //     });

    // }

    do_export() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoadingExport: true });
        this.props.exportExcel(query).catch(err => {
            this.setState({ isLoadingExport: false });
        });
        this.setState({ isLoadingExport: false });
        NotificationManager.success("Quá trình xuất file đang được thực hiện. Vui lòng kiểm tra email của bạn sau ít phút.", "Thông báo", 9000);
    }

    render() {
        var { product_receipt_import_list, pagination, product_supplier_active_list, product_warehouse_active_list } = this.props;
        var { isLoading, selectedRowKeys, isOpenForm, currentItem, current_id, isOpenDetail, loadingDetail, isLoadingExport } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;
        var query = qs.parse(this.props.location.search.slice(1));

        const columns = [
            {
                title: 'Mã phiếu',
                dataIndex: 'code',
                key: 'code',
                width: '100px'
            },
            {
                title: '#',
                width: '40px',
                align: 'center',
                render: (text, record) => (
                    <div>
                        {
                            checkPermission('product_receipt_import', 'remove') ? (
                                <DeleteOutlined style={{ color: 'red', cursor: 'pointer' }} onClick={() => this.openAlert([record.id])} />
                            ) : null
                        }
                    </div>
                )
            },
            {
                title: 'Tên phiếu',
                dataIndex: 'name',
                key: 'name',
                render: (text, record) => {
                    if (record.name) {
                        if (checkPermission('product_receipt_import', 'detail')) {
                            return (
                                <Tooltip title="Xem chi tiết" placement="right">
                                    <div className='color-primary item-action-btn' onClick={() => this.onDetail(record.id)}>
                                        {record.name}
                                    </div>
                                </Tooltip>
                            )
                        } else {
                            return (
                                <>{record.name}</>
                            )
                        }
                    } else {
                        return <>N/A</>
                    }
                }
            },
            {
                title: 'Loại phiếu',
                dataIndex: 'type',
                key: 'type',
                width: '100px',
                render: (text, record) => {
                    return (<>{ConvertProductReceiptImportType(text)}</>)
                }
            },
            {
                title: 'Kho',
                dataIndex: 'warehouse_name',
                key: 'warehouse_name',
                width: '150px'
            },
            {
                title: 'Nhà cung cấp',
                dataIndex: 'supplier_name',
                key: 'supplier_name',
                width: '250px'
            },
            {
                title: 'Tổng tiền',
                dataIndex: 'total_amount',
                key: 'total_amount',
                width: '120px',
                render: (text, record) => {
                    return (
                        <NumberFormat value={text} displayType={'text'} suffix="đ" thousandSeparator={true} />
                    )
                }
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '200px',
                render: (text, record) => {
                    return (
                        <div style={{ wordBreak: "break-word" }}>
                            <Tooltip title={HtmlParser(text)} placement="topLeft">
                                <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'Ngày nhập',
                dataIndex: 'import_date',
                key: 'created_at',
                sorter: true,
                width: '120px',
                render: (text, record) => {
                    return (
                        <div>{isValidDate(text, false)}</div>
                    )
                }
            },
            {
                title: 'Ngày lập phiếu',
                dataIndex: 'created_at',
                key: 'created_at',
                sorter: true,
                width: '150px',
                render: (text, record) => {
                    return (
                        <div>{isValidDate(text, true)}</div>
                    )
                }
            }
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Phiếu nhập kho" />
                <div>
                    <TableActionBar
                        isShowAddButton={checkPermission('product_receipt_import', 'create')}
                        isShowDeleteButton={checkPermission('product_receipt_import', 'remove')}
                        onAdd={() => this.toggleOpenForm(true)}
                        addText="Tạo phiếu mới"
                        onDelete={() => this.onRemove()}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        activeFilter={
                            query.created_date_start ||
                            query.created_date_end ||
                            query.vat_status ||
                            query.supplier_id
                        }
                        filters={
                            [
                                <BaseSelect
                                    options={vatStatuses || []}
                                    onChange={(value) => this.onChangeFilter("vat_status", value)}
                                    optionValue="value"
                                    showSearch
                                    defaultValue={query.vat_status || null}
                                    optionLabel="label"
                                    placeholder="Trạng thái VAT"
                                    className="w-100"
                                />,
                                <BaseSelect
                                    options={product_supplier_active_list || []}
                                    onChange={(value) => this.onChangeFilter("supplier_id", value)}
                                    optionValue="id"
                                    showSearch
                                    defaultValue={parseInt(query.supplier_id) || null}
                                    optionLabel="name"
                                    placeholder="Nhà cung cấp"
                                    className="w-100"
                                />,
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Ngày nhập', 'Đến ngày']}
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('created_at', value)}
                                    defaultValue={[query.created_date_start ? moment(query.created_date_start, 'YYYY-MM-DD') : null, query.created_date_end ? moment(query.created_date_end, 'YYYY-MM-DD') : null]}
                                />
                            ]
                        }
                    >
                        <BaseSelect
                            options={product_warehouse_active_list || []}
                            onChange={(value) => this.onChangeFilter("warehouse_id", value)}
                            optionValue="id"
                            showSearch
                            defaultValue={parseInt(query.warehouse_id) || null}
                            optionLabel="name"
                            placeholder="Kho hàng"
                            style={{ width: '150px' }}
                            className="table-button"
                        />
                        <BaseSelect
                            options={ProductReceiptImportType}
                            onChange={(value) => this.onChangeFilter("type", value)}
                            defaultValue={query.type || null}
                            placeholder="Loại phiếu"
                            style={{ width: '150px' }}
                            className="table-button"
                        />
                        {
                            checkPermission('product_receipt_import', 'export') ? (
                                <Button className="table-button" loading={isLoadingExport} type='default' onClick={() => this.do_export()} icon={<ExportOutlined />}>Xuất file excel</Button>
                            ) : null
                        }
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.reloadData()}>Refresh</Button>
                    </TableActionBar>
                    {
                        hasSelected ? <Row className="mb-2" align="middle">Đang chọn {selectedRowKeys.length} bản ghi </Row> : ''
                    }
                </div>
                <Table
                    rowKey="id"
                    size="small"
                    tableLayout='auto'
                    dataSource={product_receipt_import_list || []}
                    columns={columns}
                    loading={isLoading}
                    rowSelection={rowSelection}
                    pagination={{
                        pageSize: pagination.perPage,
                        current: pagination.currentPage,
                        total: pagination.total,
                        showTotal: total => `Tổng ${total} bản ghi`,
                        defaultPageSize: 30, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '40', '50', '100', '200']
                    }}
                    onChange={(pagination, filters, sorter) => this.onChangeTable(pagination, sorter)}
                    scroll={{
                        x: 'max-content'
                    }}
                />
                <ProductReceiptImportForm
                    visible={isOpenForm}
                    currentItem={currentItem}
                    reloadData={() => this.reloadData()}
                    onCancel={() => this.toggleOpenForm(false)}
                />

                <ProductReceiptImportDetail
                    visible={isOpenDetail}
                    currentItem={currentItem}
                    reloadData={() => this.onDetail(current_id)}
                    onCancel={() => this.toggleOpenDetail(false)}
                    loadingDetail={loadingDetail}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        product_receipt_import_list: state.ProductReceiptImportReducer.product_receipt_import_list,
        pagination: state.ProductReceiptImportReducer.pagination,
        product_supplier_active_list: state.ProductSupplierReducer.product_supplier_active_list,
        product_warehouse_active_list: state.ProductWarehouseReducer.product_warehouse_active_list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getAllProductReceiptImport: (filter) => dispatch(getAllProductReceiptImport(filter)),
        getSpecificProductReceiptImport: (id) => dispatch(getSpecificProductReceiptImport(id)),
        removeProductReceiptImport: (ids) => dispatch(removeProductReceiptImport(ids)),
        getProductSupplierActive: () => dispatch(getProductSupplierActive()),
        getProductWarehouseActive: () => dispatch(getProductWarehouseActive()),
        exportExcel: (filter) => dispatch(exportExcel(filter))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductReceiptImportList);
